import { render, staticRenderFns } from "./InviteSucceed.vue?vue&type=template&id=90b5f004&scoped=true&lang=html&"
import script from "./InviteSucceed.vue?vue&type=script&lang=js&"
export * from "./InviteSucceed.vue?vue&type=script&lang=js&"
import style0 from "./InviteSucceed.vue?vue&type=style&index=0&id=90b5f004&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b5f004",
  null
  
)

export default component.exports